import { Redirect, Switch } from "react-router-dom";

import Layout from "components/Layout";
import AuthRoute from "components/AuthRoute";

import ClientesPages from "./Clientes";
import DashboardPage from "./Dashboard";
import CadastrosPages from "./Cadastros";
import RelatoriosPages from "./Relatorios";
import CondominioPages from "./Condominio";
import FinanceiroPages from "./Financeiro";
import UsuariosPages from "./UsuariosPages";
import EditarPerfilPages from "./EditarPerfil";
import AdministracaoPages from "./Administracao";
import CondominioDetalhesPage from "./Condominio/Detalhes";
import { PermissaoEnum } from "core/resources/enums/permissao";

function Admin() {
  return (
    <Layout>
      <Switch>
        <AuthRoute path="/cadastros" component={CadastrosPages} />
        <AuthRoute
          path="/usuarios"
          component={UsuariosPages}
          permissions={[
            PermissaoEnum.Backoffice.Administrativo.Usuario.Visualizar,
          ]}
        />

        <AuthRoute
          path="/clientes"
          component={ClientesPages}
          permissions={[PermissaoEnum.Backoffice.Admin.Clientes.Visualizar]}
        />
        <AuthRoute path="/financeiro" component={FinanceiroPages} />
        <AuthRoute
          path="/empresa"
          component={CondominioDetalhesPage}
          permissions={[PermissaoEnum.Backoffice.PerfilEmpresa.Editar]}
        />
        <AuthRoute path="/dashboard" component={DashboardPage} />
        <AuthRoute path="/administracao" component={AdministracaoPages} />

        <AuthRoute path="/condominio" component={CondominioPages} />
        <AuthRoute
          path="/meu-condominio"
          component={CondominioDetalhesPage}
          permissions={[PermissaoEnum.Backoffice.DadosCondominio.Gerenciar]}
        />
        <AuthRoute path="/editar-perfil" component={EditarPerfilPages} />
        <AuthRoute path="/relatorios" component={RelatoriosPages} />

        <Redirect path="/" to="/dashboard" />
      </Switch>
    </Layout>
  );
}

export default Admin;
